module.exports = __webpack_public_path__ + "img/gsq25_detail.3b855ea2.jpg";